<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 justify-content-center" *ngIf="sdkInitTexts">
      <label class="router-message">
        <label class="router">
          <nz-countdown [nzValue]="deadline" (nzCountdownFinish)="stop('UyeIsyerineOtomatikDonus')" [nzFormat]="'ss'"></nz-countdown>
        </label>
        {{this.textService.keyValueMapping('returnUrlSecond', 'saniye içinde', sdkInitTexts)}} {{redirectToSiteName}}
        {{this.textService.keyValueMapping('returnUrlText', '’a yönlendirileceksiniz.', sdkInitTexts)}}</label>
      <p><label class="router-link"><a
        (click)="stop('UyeIsyerineDonus')">{{this.textService.keyValueMapping('goToSiteButton', 'Siteye git', sdkInitTexts)}}</a></label>
      </p>
    </div>
  </div>
</div>
